import Vue from 'vue'

import Logo404 from '@/common/components/logo/Logo404.vue'
import LogoStandard from '@/common/components/logo/LogoStandard.vue'
import LogoEaster from '@/common/components/logo/LogoEaster.vue'
import LogoChristmas from '@/common/components/logo/LogoChristmas.vue'
import LogoComposite from '@/common/components/logo/LogoComposite.vue'

Vue.component('logo-404', Logo404)
Vue.component('logo-standard', LogoStandard)
Vue.component('logo-easter', LogoEaster)
Vue.component('logo-christmas', LogoChristmas)
Vue.component('logo-composite', LogoComposite)
